import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/BreakdownEffectActions";
import * as api from "../../api/BreakdownEffectApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getBreakdownEffects(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getBreakdownEffects(action.payload);
        yield put(actions.setBreakdownEffects(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownEffects(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addBreakdownEffect(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addBreakdownEffect(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateBreakdownEffect(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateBreakdownEffect(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteBreakdownEffect(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteBreakdownEffect(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_BREAKDOWN_EFFECTS, getBreakdownEffects);
    yield takeEvery(actions.Types.ADD_BREAKDOWN_EFFECT, addBreakdownEffect);
    yield takeEvery(actions.Types.UPDATE_BREAKDOWN_EFFECT, updateBreakdownEffect);
    yield takeEvery(actions.Types.DELETE_BREAKDOWN_EFFECT, deleteBreakdownEffect);
}

const BreakdownEffectSaga = [fork(watchAll)];

export default BreakdownEffectSaga;
